import { render } from "./stronaKontaBody.vue?vue&type=template&id=4a8542fa&scoped=true"
import script from "./stronaKontaBody.vue?vue&type=script&lang=js"
export * from "./stronaKontaBody.vue?vue&type=script&lang=js"

import "./stronaKontaBody.vue?vue&type=style&index=0&id=4a8542fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8542fa"]])

export default __exports__